<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">EC使用画像指示</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <div class="element-column">
            <div class="block-row">
              <div class="column-list">
                <label class="list-input-title" style="width:105px">Ｐコード</label>
                <div class="list-input-content">
                  <input type="text" id="lbl_Pcode" class="pcode"
                    value="{{ this.kymw5002Model.pcode }}" readonly>
                </div>
              </div>

              <div class="column-list">
                <label class="list-input-title" style="width:105px">商品名</label>
                <div class="list-input-content">
                  <input type="text" id="lbl_GuideGoodsName" class="guide-goods-name"
                    value="{{this.kymw5002Model.guideGoodsName}}" readonly>
                </div>
              </div>

              <div class="column-list">
                <label class="list-input-title" style="width:105px">規格名</label>
                <div class="list-input-content">
                  <input type="text" id="lbl_GuideStandardName" class="guide-standard-name"
                    value="{{this.kymw5002Model.guideStandardName}}" readonly>
                </div>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title" style="width:105px">画像キャプション</label>
              <div class="list-input-content">
                <app-text-area [fullOnly]="true" id="txti_Caption" [maxChars]="50" [forcedEnabledMode]="''" [height]="48"
                  [restrict]="'[ -￮]'" #txti_Caption [subid]="'txti_Caption'" [(ngModel)]="this.kymw5002Model.textCaption"
                  [counterWidth]="'45px'" (input)="eventTxtiCaption_CHANGEHandler($any($event.target).value)"
                  [disabled]="true">
                </app-text-area>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h3>使用画像</h3>
          <app-kymw5002-use-image id="vw_UseImage" #vw_UseImage forcedEnabledMode="true"
            [useImageList]="this.kymw5002Model.useImageList"
            (eventUseImageList_ITEMCLICK)="eventUseImageList_ITEMCLICKHandler($event)">
          </app-kymw5002-use-image>
        </div>

        <div>
          <h3>検索結果</h3>
          <app-kymw5002-search-result id="vw_SearchResult" #vw_SearchResult
            (eventPcodeList_CHANGE)="eventPcodeList_CHANGEHandler($event)"
            (eventPcodeInfoList_CLICK)="eventPcodeInfoList_CLICKHandler($event)"
            (eventGoodsImageList_ITEMCLICK)="eventGoodsImageList_ITEMCLICKHandler($event)"
            (eventUseHistoryImageList_ITEMCLICK)="eventUseHistoryImageList_ITEMCLICKHandler($event)"
            (eventSearchImageList_ITEMCLICK)="eventSearchImageList_ITEMCLICKHandler($event)"
            (eventBtnSearch_CLICK)="eventBtnSearch_CLICKHandler(null)" [goodsImageList]="kymw5002Model.goodsImageList"
            [pcodeList]="kymw5002Model.pcodeList" [pcodeInfoList]="kymw5002Model.pcodeInfoList"
            [useHistoryImageList]="kymw5002Model.useHistoryImageList" [searchImageList]="kymw5002Model.searchImageList"
            forcedEnabledMode="true">
          </app-kymw5002-search-result>
        </div>

        <div>
          <h3>画像情報詳細</h3>
          <div class="element-column">
            <app-kymw5002-image-info-detail id="vw_ImageInfoDetail" #vw_ImageInfoDetail forcedEnabledMode="true"
              [goodsImagePreviewURL]="kymw5002Model.goodsImagePreviewURL"
              (changeEndOrderCode2)="bindEndOrderCodeComboBox($event.index)"
              (eventSettingCLICK)="eventSetting_CLICKHandler(null)">
            </app-kymw5002-image-info-detail>

            <div class="column-list">
              <label class="list-input-title">会員生協</label>
              <div class="list-input-content">
                <app-checkbox-label [label]="'全'" id="chk_AllCoop" #chk_AllCoop [subid]="'chk_AllCoop'"
                  [forcedEnabledMode]="'none'" [(ngModel)]="this.kymw5002Model.allCoop"
                  (change)="eventChkAllCoop_CLICKHandler()">
                </app-checkbox-label>
                <app-checkbox-label [label]="'い'" id="chk_Ibaraki" #chk_Ibaraki [subid]="'chk_Ibaraki'"
                  [forcedEnabledMode]="'none'" [(ngModel)]="this.kymw5002Model.ibaraki" (change)="eventChkCoop_CLICKHandler()">
                </app-checkbox-label>
                <app-checkbox-label [label]="'と'" id="chk_Tochigi" #chk_Tochigi [subid]="'chk_Tochigi'"
                  [forcedEnabledMode]="'none'" [(ngModel)]="this.kymw5002Model.tochigi" (change)="eventChkCoop_CLICKHandler()">
                </app-checkbox-label>
                <app-checkbox-label [label]="'ぐ'" id="chk_Gunma" #chk_Gunma [subid]="'chk_Gunma'"
                  [forcedEnabledMode]="'none'" [(ngModel)]="this.kymw5002Model.gunma" (change)="eventChkCoop_CLICKHandler()">
                </app-checkbox-label>
                <app-checkbox-label [label]="'ち'" id="chk_Chiba" #chk_Chiba [subid]="'chk_Chiba'"
                  [forcedEnabledMode]="'none'" [(ngModel)]="this.kymw5002Model.chiba" (change)="eventChkCoop_CLICKHandler()">
                </app-checkbox-label>
                <app-checkbox-label [label]="'さ'" id="chk_Saitama" #chk_Saitama [subid]="'chk_Saitama'"
                  [forcedEnabledMode]="'none'" [(ngModel)]="this.kymw5002Model.saitama" (change)="eventChkCoop_CLICKHandler()">
                </app-checkbox-label>
                <app-checkbox-label [label]="'とう'" id="chk_Tokyo" #chk_Tokyo [subid]="'chk_Tokyo'"
                  [forcedEnabledMode]="'none'" [(ngModel)]="this.kymw5002Model.tokyo" (change)="eventChkCoop_CLICKHandler()">
                </app-checkbox-label>
                <app-checkbox-label [label]="'な'" id="chk_Nagano" #chk_Nagano [subid]="'chk_Nagano'"
                  [forcedEnabledMode]="'none'" [(ngModel)]="this.kymw5002Model.nagano" (change)="eventChkCoop_CLICKHandler()">
                </app-checkbox-label>
                <app-checkbox-label [label]="'に'" id="chk_Niigata" #chk_Niigata [subid]="'chk_Niigata'"
                  [forcedEnabledMode]="'none'" [(ngModel)]="this.kymw5002Model.niigata" (change)="eventChkCoop_CLICKHandler()">
                </app-checkbox-label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Setting" #btn_Setting class="btn-primary" [tabindex]="0"
            (click)="eventSetting_CLICKHandler($event)">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventBtnClose_CLICKHandler(null)"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>